angular.module('unergie.main')
.factory('TimelineService', () => {
    const margin = {
        top: 10,
        right: 20,
        bottom: 40,
        left: 30,
    }

    const formatTs = (ts) => moment(ts * 1000).format('DD/MM/YY')

    const display = function (svg, width, height, model, data) {
        const listReading = data.listReading.filter((d) => model.nature[d.class] && model.tempClass[d.temp_class])

        const {
            estimated,
            mStartDate,
            mEndDate,
        } = data

        const widthNoMargin = width - margin.left - margin.right
        const heightNoMargin = height - margin.top - margin.bottom

        const g = svg.append('g').attr('transform', `translate(${margin.left},${margin.top})`)

        const x = d3.scaleLinear().range([0, widthNoMargin])
        const y = d3.scaleLinear().range([heightNoMargin, 0])

        const valueline = d3.line()
        .x((d) => x(d.date))
        .y((d) => y(d.value))

        listReading.forEach((elem, i) => {
            const previous = listReading[i - 1]
            elem.xOffset = elem.start_date.unix()
            elem.width = elem.end_date.unix() - elem.start_date.unix()
            elem.height = Math.abs(elem.cons) / (elem.end_date.diff(elem.start_date, 'days') || 1)

            if (previous && previous.start_date.isSame(elem.start_date) && previous.end_date.isSame(elem.end_date)) {
                if (elem.cons >= 0) {
                    elem.yOffset = previous.yOffset + previous.height
                }
                else {
                    elem.yOffset = previous.yOffset - elem.height
                }
            }
            else {
                elem.yOffset = (elem.cons >= 0) ? 0 : -elem.height
            }
        })

        const totalWidth = mEndDate.unix() - mStartDate.unix()
        const ctcEstimated = model.estimated && estimated && estimated.daily.reduce((acc, day, i) => {
            const date = moment(estimated.timePeriod.startDate).add(i, 'day').unix()

            if (day.sum != null && model.tempClass.HP && model.tempClass.HC) {
                if (!acc.sum) {
                    acc.sum = []
                }

                acc.sum.push({
                    date,
                    value: day.sum,
                })
            }

            _.forEach(day.ctc, (value, key) => {
                const tempClass = key.split('.')[1]

                if (model.tempClass[tempClass]) {
                    if (!acc[tempClass]) {
                        acc[tempClass] = []
                    }

                    acc[tempClass].push({
                        date,
                        value,
                    })
                }
            })

            return acc
        }, {})

        let heightsArray = _.map(listReading, (d) => ((d.cons >= 0) ? (d.yOffset + d.height) : d.yOffset)).concat(0)
        if (ctcEstimated) {
            _.forEach(ctcEstimated, (value, key) => {
                return (heightsArray = heightsArray.concat(_.map(value, 'value')))
            })
        }

        x.domain([mStartDate.unix(), mEndDate.unix()])
        y.domain([d3.min(heightsArray), d3.max(heightsArray)])

        const tooltipReading = (elem) => {
            const a = `${elem.start_date.format('DD/MM/YYYY')} -> ${elem.end_date.format('DD/MM/YYYY')}`
            const b = `<br/>${elem.cons}kWh (${parseInt(elem.cons / (elem.end_date.diff(elem.start_date, 'days')), 10)}/j)`
            const c = `<br/>${elem.temp_class}<br/>${elem.index_nature}`

            return `${a}${b}${c}`
        }

        const tooltipLine = (tempClass, elem) => {
            const a = `${tempClass} (estimé)`
            const b = `<br/>${moment.unix(elem.date).format('DD/MM/YYYY')}<br/>${elem.value}kWh`

            return `${a}${b}`
        }

        const colorFromNature = {
            'REEL': {
                BASE: '#4086bf',
                HP: '#4086bf',
                HC: '#8cb6d9',
            },
            'AUTO-RELEVE': {
                BASE: '#40bf91',
                HP: '#40bf91',
                HC: '#8cd9bd',
            },
            'ESTIME': {
                BASE: '#8040bf',
                HP: '#8040bf',
                HC: '#b38cd9',
            },
            'default': {
                BASE: '#bf8c40',
                HP: '#bf8c40',
                HC: '#d9ba8c',
            },
        }

        const tooltipOn = function (tooltipFunc, d) {
            svg.tooltip.transition()
            .duration(200)
            .style('opacity', 0.9)

            return svg.tooltip.html(tooltipFunc(d))
            .style('left', `${d3.event.pageX + 20}px`)
            .style('top', `${d3.event.pageY - 28}px`)
        }

        const tooltipOff = (d) => {
            return svg.tooltip.transition().duration(500).style('opacity', 0)
        }

        g.selectAll('.bin')
        .data(listReading)
        .enter().append('rect')
        .attr('class', 'reading')
        .attr('ry', 3)
        .attr('x', (d) => x(d.xOffset))
        .attr('width', (d) => (d.width / totalWidth) * widthNoMargin)
        .attr('y', (d) => y(d.yOffset + d.height))
        .attr('height', (d) => y(0) - y(d.height))
        .attr('fill', (d) => (colorFromNature[d.index_nature] || colorFromNature.default)[d.temp_class])
        .style('opacity', 0.7)
        .on('mouseover', tooltipOn.bind(null, tooltipReading))
        .on('mouseout', tooltipOff)

        if (ctcEstimated) {
            _.forEach(ctcEstimated, (value, tempClass) => {
                const cssClass = tempClass.toLowerCase()

                g.append('path')
                .attr('class', cssClass)
                .attr('d', valueline(value))

                return g.selectAll('dot')
                .data(value)
                .enter().append('circle')
                .attr('class', cssClass)
                .attr('r', 2.4)
                .attr('cx', (d) => x(d.date))
                .attr('cy', (d) => y(d.value))
                .on('mouseover', tooltipOn.bind(null, tooltipLine.bind(null, tempClass)))
                .on('mouseout', tooltipOff)
            })
        }

        g.append('g')
        .attr('class', 'x axis')
        .attr('transform', `translate(0,${y(0)})`)
        .call(d3.axisBottom(x)
        .tickFormat(formatTs))

        g.append('g')
        .attr('class', 'y axis')
        .call(d3.axisLeft(y))

        g.selectAll('.bin')
        .data(listReading)
        .enter().append('text')
        .attr('x', (d) => (x(d.xOffset) + (((d.width / totalWidth) * widthNoMargin) / 2)) - 8)
        .attr('y', (d) => y(d.yOffset + (d.height / 2)))
        .attr('dy', '.35em')
        .attr('fill', 'white')
        .text((d) => d.cons)
        .on('mouseover', tooltipOn.bind(null, tooltipReading))
        .on('mouseout', tooltipOff)

        return g.selectAll('.x text').attr('transform', 'translate(-13,11)rotate(-45)')
    }

    return {
        display,
    }
})
